<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                      style="min-height: 300px"
                      pulling-text="下拉重新获取数据"
                      loosing-text="释放即可重新加载"
                      loading-text=""
                      success-text="数据获取成功">
        <div>
            <van-sticky style="height: 0px">高度为0，不显示，添加此标签，用于下拉刷新时，搜索框等固定位置的布局，不受到下边的"top: 160px"影响</van-sticky>
            <div style="width: 100%; min-height: 140px; background-color: white;position: fixed; top:0px; z-index: 1999; box-shadow: 0px 1px 5px #999">
                <!--                <div style="margin-bottom: 3%; text-align: center">-->
                <!--                    <table style="width: 100%" cellspacing="0" border-collapse="1">-->
                <!--                        <tr style="background-color: #dddddd">-->
                <!--                            <td style="width: 80%">-->
                <!--                                <van-search-->
                <!--                                        style="padding-right: 5px"-->
                <!--                                        background="#dddddd"-->
                <!--                                        v-model="serch_value"-->
                <!--                                        placeholder="请输入搜索关键词"-->
                <!--                                        shape="square"-->
                <!--                                >-->
                <!--&lt;!&ndash;                                    <div size="large" type="danger" slot="action" @click="clickToSearch">搜索</div>&ndash;&gt;-->
                <!--                                </van-search>-->

                <!--                            </td>-->
                <!--                            <td style="text-align: center">-->
                <!--                                <van-button type="danger"-->
                <!--                                            size="small"-->
                <!--                                            v-on:click="clickToSearch"-->
                <!--                                >搜索-->
                <!--                                </van-button>-->
                <!--                            </td>-->
                <!--                        </tr>-->
                <!--                    </table>-->
                <!--                </div>-->

                <div style="margin: 15px">
                    <van-field
                            style="padding: 0px;"
                    >
                        <div slot="input" style="margin-right: -10px;  background-color: #aaaaaa; padding: 1px; border-radius:5px 0px 0px 5px">
                            <van-field
                                    style=" border-radius:4px 0px 0px 4px; padding: 0px; border-color: #aaaaaa"
                                    v-model="serch_value"
                                    placeholder="请输入搜索关键词"
                                    clearable
                            >
                                <div slot="left-icon" style="width: 10px"></div>
                                <div slot="button" style="height: 40px; background-color: orange"></div>
                            </van-field>
                        </div>

                        <van-field
                                slot="button"
                                style="padding: 0px; border-radius:0px 5px 5px 0px">
                            <div slot="input" style="width: 0px" ></div>
                            <van-button slot="button" type="danger" icon="search"
                                        style="height: 42px; border: 5px; margin-left: -10px"
                                        v-on:click="clickToSearch"
                            >搜索
                            </van-button>
                        </van-field>
                    </van-field>
                </div>


                <van-checkbox-group v-model="check_result">
                    <van-row style="margin-left: 15px; margin-top: 20px; margin-bottom: 16px">
                        <van-col span="7">
                            <van-checkbox :name="check_list[0]" shape="round" checked-color="#ff0000">
                                {{check_list[0]}}
                            </van-checkbox>
                        </van-col>
                        <van-col span="7">
                            <van-checkbox :name="check_list[1]" shape="round" checked-color="#ff0000">
                                {{check_list[1]}}
                            </van-checkbox>
                        </van-col>
                        <van-col span="5">
                            <van-checkbox :name="check_list[2]" shape="round" checked-color="#ff0000">
                                {{check_list[2]}}
                            </van-checkbox>
                        </van-col>
                        <van-col span="5">
                            <van-checkbox :name="check_list[3]" shape="round" checked-color="#ff0000">
                                {{check_list[3]}}
                            </van-checkbox>
                        </van-col>
                    </van-row>
                    <!--                <van-row style="margin-left: 5%; margin-right: 5%; margin-top: 5%; margin-bottom: 2%">-->

                    <!--                </van-row>-->
                </van-checkbox-group>


                <div style="margin-left: 15px; margin-bottom: 10px; font-size: 11px; color: orange">
                    <span>*输入"关键词"或勾选"筛选类别"后，点击[搜索]，进行商品搜索</span>
                </div>
            </div>

            <div v-if="list" style="position: relative; top: 160px; margin-bottom: 180px">

                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="已获取全部数据~"
                        @load="onLoad"
                >
                    <div v-if="position_id">
                        <JdSkuInfoCard_ForUser
                                v-for="sku_info in list"
                                v-bind:key="sku_info.skuId"
                                :skuInfo="sku_info"
                                :position_id="position_id"
                        ></JdSkuInfoCard_ForUser>
                    </div>
                </van-list>
            </div>

        </div>

    </van-pull-refresh>
</template>

<script>
    import JdSkuInfoCard_ForUser from "../pages_user/JdSkuInfoCard_ForUser";

    export default {
        name: "Wp_jd_select_for_member",
        components: {JdSkuInfoCard_ForUser},
        props: {
            position_id: {
                type: String,
                default: ''
            },
            keyword: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                // sku_info:null
                base_data_array: null,
                check_list: ['京东自营', '优惠券', '拼购', '爆款'],
                check_result: [],
                serch_value: '',
                //下拉刷新结束
                isLoading: false,

                //上拉加载的临时list
                list: [],
                //上拉加载状态结束
                loading: false,
                //数据全部加载完成的状态
                finished: false,

                //请求数据页码
                page_index: 1,
                //一次页面请求多少数据
                page_size: 20,
                //包含check_result的参数
                params_with_queryparam: null,

                // first_position: 0,
            }
        },

        // created(){
        //     this.mediaId = this.$getUrlParamValue("media_id")
        //     this.$log("111mediaId = " + this.mediaId);
        // },

        mounted() {
            // this.getGoodsDataNoParams();
            if (this.position_id) {
                // this.check_result.push(this.check_list[0]);
                this.check_result.push(this.check_list[1]);
            }
            if (this.keyword) {
                this.serch_value = this.keyword;
            }
        },


        methods: {
            /**
             * 上拉加载
             */
            onLoad() {
                // 更新数据
                setTimeout(() => {
                    if (this.params_with_queryparam) {
                        //设置最新的页码
                        this.params_with_queryparam.pageIndex = this.page_index;
                        this.getGoodsDataWithParams(this.params_with_queryparam, datas => {
                            this.loadDatas(datas);
                        })
                    } else {
                        //没有查询参数，获取全部数据
                        this.getGoodsDataNoParams(datas => {
                            this.loadDatas(datas);
                        });
                    }

                }, 2000);
            },

            loadDatas(datas) {
                if (datas) {
                    //list一次加载的数据
                    let limit = this.page_size;
                    //如果总数据数组的length小于没次加载的限制值，则直接使用数组length
                    if (datas.length < limit) {
                        limit = datas.length;
                        //如果一次获取到的数据，小于限制的数值，则表示数据已全部获取完成
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }

                    for (let i = 0; i < limit; i++) {
                        this.list.push(datas[i]);
                    }

                    // 加载状态结束
                    this.loading = false;

                    this.page_index += 1;
                } else {
                    // 加载状态结束
                    this.loading = false;
                    // 获取数据结束
                    this.finished = true;
                }
                //关闭下拉刷新
                this.isLoading = false;
            },


            /**
             * 下拉刷新
             */
            onRefresh() {
                setTimeout(() => {
                    // this.base_data_array = null;
                    this.list = [];
                    this.params_with_queryparam = null;
                    this.page_index = 1;
                    this.check_result = [];
                    this.serch_value = '';

                    //获取所有数据
                    this.onLoad();
                }, 500);
            },

            /**
             * 根据条件查询数据
             */
            clickToSearch() {
                this.list = [];
                this.page_index = 1;

                this.finished = false;
                this.loading = true;

                //如果搜索框为空，并且没有选择任何类型，则获取全部数据
                if (!this.serch_value && (!this.check_result || this.check_result.length === 0)) {
                    // this.$toast({
                    //     message:'请输出要搜索的关键词，或选择要查询的类型',
                    //     duration: 2000
                    // })
                    // return;
                    this.params_with_queryparam = null;
                } else {
                    let json_params = this.getBaseParams();

                    //先判断搜索框是否有值
                    if (this.serch_value) {
                        json_params.keyword = this.serch_value;
                    }
                    //判断复选框是否有选中的值
                    if (this.check_result && this.check_result.length > 0) {
                        for (let i = 0; i < this.check_result.length; i++) {

                            if (this.check_result[i] === this.check_list[0]) {
                                //京东自营
                                json_params.owner = "g";
                            } else if (this.check_result[i] === this.check_list[1]) {
                                //优惠券
                                json_params.isCoupon = 1;
                            } else if (this.check_result[i] === this.check_list[2]) {
                                //拼购
                                json_params.isPG = 1;
                            } else if (this.check_result[i] === this.check_list[3]) {
                                //爆款
                                json_params.isHot = 1;
                            }
                        }
                    }
                    this.params_with_queryparam = json_params;
                }
                //手动调用onLoad方法获取数据
                this.onLoad();
            },


            /**
             * 获取所有数据(不指定特别参数)
             * @param fn 是否运行onLoad，对于选择不同标签以及搜索的结果，都需要调用onLoad()，需要传入true
             */
            getGoodsDataNoParams(fn) {
                let json_params = this.getBaseParams();
                this.getGoodsDataWithParams(json_params, fn);
            },

            /**
             * 根据指定的params获取数据
             */
            getGoodsDataWithParams(params, fn) {
                this.$getSelectGoods(params, response => {

                    this.base_data_array = response.data;
                    if (fn) {
                        fn(this.base_data_array)
                        //重新调用onLoad()之前需重置list和fist_position
                        // this.list = [];
                        // this.first_position = 0;
                        // this.onLoad();
                    }
                })
            },

            /**
             * 获取基础参数，主要将app_key和app_secret进行赋值
             * @return
             */
            getBaseParams() {
                let json_params = this.$getSelectGoodsParams();
                let mediaId = this.$common.mediaId_70637;
                if (this.position_id) {

                    //如果是用户直接使用选品页面，则默认包含"自营""优惠券"进行搜索
                    // if(this.check_result.indexOf(this.check_list[0]) > -1){
                    //     //京东自营
                    //     json_params.owner = "g";
                    // }
                    if (this.check_result.indexOf(this.check_list[1]) > -1) {
                        //优惠券
                        json_params.isCoupon = 1;
                    }

                    if (this.keyword && this.serch_value) {
                        //搜索关键字
                        json_params.keyword = this.keyword;
                    }
                } else {
                    this.$toast.fail({
                        message: '数据异常',
                    });
                    return null;
                }
                json_params.app_key = this.$common.getAppKeyInfo(mediaId).app_key;
                json_params.app_secret = this.$common.getAppKeyInfo(mediaId).app_secret;
                json_params.pageIndex = this.page_index;
                json_params.pageSize = this.page_size;
                return json_params;
            },

        },
        watch: {
            // list(newList){
            //     if(newList.length > 0){
            //         this.topPx = '160px';
            //     }else{
            //         this.topPx = '0px';
            //     }
            // }
        //     check_result(newResult) {
        //         // if(this.list === null || this.list.length ===0){
        //         //     this.$toast("操作请勿频繁")
        //         // }
        //
        //         this.list = [];
        //         this.page_index = 1;
        //
        //         this.finished = false;
        //         this.loading = true;
        //
        //         if (newResult && newResult.length > 0) {
        //             let json_params = this.getBaseParams();
        //             //如果搜索框中有关键词，则选择获取指定类别数据时，将关键词也配置到参数中
        //             if (this.serch_value) {
        //                 json_params.keyword = this.serch_value;
        //             }
        //
        //             for (let i = 0; i < newResult.length; i++) {
        //
        //                 if (newResult[i] === this.check_list[0]) {
        //                     //京东自营
        //                     json_params.owner = "g";
        //                 } else if (newResult[i] === this.check_list[1]) {
        //                     //优惠券
        //                     json_params.isCoupon = 1;
        //                 } else if (newResult[i] === this.check_list[2]) {
        //                     //拼购
        //                     json_params.isPG = 1;
        //                 } else if (newResult[i] === this.check_list[3]) {
        //                     //爆款
        //                     json_params.isHot = 1;
        //                 }
        //             }
        //
        //             // this.getGoodsDataWithParams(json_params, true);
        //             this.params_with_queryparam = json_params;
        //
        //         } else {
        //             //如果为空，则获取全部数据
        //             // this.getGoodsDataNoParams(true);
        //             this.params_with_queryparam = null;
        //         }
        //
        //         this.onLoad();
        //
        //     }
        }
    }
</script>

<style scoped>

</style>
